<template>
  <div class="app-container">
    <div class="table-box">
      <el-form
        :model="queryParams"
        ref="queryForm"
        size="small"
        :inline="true"
        v-show="showSearch"
        label-width="100px"
      >
        <el-form-item label="行政区划" prop="address">
          <el-input
            v-model="queryParams.address"
            placeholder="请输入行政区划"
            clearable
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="淤地坝名称" prop="ydbmc">
          <el-input
            v-model="queryParams.ydbmc"
            placeholder="请输入淤地坝名称"
            clearable
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            @click="handleQuery"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
            >重置</el-button
          >
        </el-form-item>
      </el-form>

      <el-table
        v-loading="loading"
        :data="ydbSensoerInfoOldList"
        max-height="680"
      >
        <el-table-column label="淤地坝名称" align="center" prop="ydbmc" />
        <el-table-column label="行政区划" align="center" prop="address" />
        <el-table-column label="淤地坝代码" align="center" prop="ydbdm" />
        <el-table-column label="淤地坝规模" align="center" prop="gcgm" />
        <el-table-column
          label="实时数据"
          align="left"
          header-align="center"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.sp > 0"
              type="primary"
              size="mini"
              @click="onClickSP(scope.row)"
              >视频</el-button
            >
            <el-button
              v-if="scope.row.yl > 0"
              type="success"
              size="mini"
              @click="getSnListByType(scope.row, 3)"
              >雨量</el-button
            >
            <el-button
              class="sw-btn"
              v-if="scope.row.sw > 0"
              size="mini"
              @click="getSnListByType(scope.row, 1)"
              >水位</el-button
            >
            <el-button
              v-if="scope.row.wy > 0"
              type="warning"
              size="mini"
              @click="getSnListByType(scope.row, 5)"
              >位移</el-button
            >
            <el-button
              v-if="scope.row.sl > 0"
              type="danger"
              size="mini"
              @click="getSnListByType(scope.row, 4)"
              >渗流</el-button
            >
            <el-button
              class="sy-btn"
              v-if="scope.row.sy > 0"
              size="mini"
              @click="getSnListByType(scope.row, 6)"
              >渗压</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>

    <div class="hk-video-box" v-if="showHkVideo">
      <hk-video-player
        :videoInfo="videoInfo"
        :yzdList="yzdList"
        @closeVideoClick="showHkVideo = false"
      />
    </div>

    <!-- 添加或修改淤地坝设备信息对话框 -->
    <el-dialog
      :title="title"
      :visible.sync="open"
      width="1100px"
      append-to-body
    >
      <div class="current-info">
        <!-- 雨量实时数据 -->
        <div v-if="form.type == '3' && form.now && form.now.length > 0">
          <span class="c-item" v-for="(rain, index) in form.now" :key="index">
            {{ rain.name }}:{{ rain.data }}mm
          </span>
          <span class="c-item"
            >状态： {{ form.now[0].status == "0" ? "在线" : "断传" }}</span
          >
          <span class="c-item">时间： {{ form.now[0].time }}</span>
        </div>
        <!-- 水位实时数据 -->
        <div v-if="form.now && form.now.data">
          <span class="c-item" v-if="form.type == '1' || form.type == '2'"
            >水位高程： {{ form.now.data }}m</span
          >
        </div>
        <!-- 位移实时数据 -->
        <div v-if="form.now">
          <span class="c-item" v-if="form.type == '5'"
            >X: {{ form.now.totalDX }}mm</span
          >
          <span class="c-item" v-if="form.type == '5'"
            >Y: {{ form.now.totalDY }}mm</span
          >
          <span class="c-item" v-if="form.type == '5'"
            >Z: {{ form.now.totalDZ }}mm</span
          >
        </div>
        <!-- 公共状态和时间 -->
        <span class="c-item" v-if="form.now && form.now.status"
          >状态： {{ form.now.status == "0" ? "在线" : "断传" }}</span
        >
        <span class="c-item" v-if="form.now && form.now.time"
          >时间： {{ form.now.time }}</span
        >
      </div>
      <el-form
        :model="form"
        ref="form"
        size="small"
        :inline="true"
        label-width="100px"
      >
        <el-form-item prop="snInfo">
          <el-select
            v-model="snInfo"
            @change="getSensorRealtimeData"
            placeholder="请选择传感器"
          >
            <el-option
              v-for="item in realtimeDataOptions"
              :key="item.id"
              :label="item.name"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="checkTime">
          <el-date-picker
            v-model="form.checkTime"
            type="datetimerange"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :append-to-body="false"
            align="right"
            format="yyyy-MM-dd HH:00:00"
            value-format="timestamp"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            @click="handleQueryByTime"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
      <div id="chart-box">暂无数据</div>
    </el-dialog>
  </div>
</template>

<script>
import pagination from "@/components/Pagination/index.vue";
import Axios from "axios";
import * as echarts from "echarts";
import hkVideoPlayer from "@/components/hkVideoPlayer/index.vue";

export default {
  name: "YdbSensoerInfoOld",
  components: { pagination, hkVideoPlayer },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 淤地坝设备信息表格数据
      ydbSensoerInfoOldList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        ydbId: null,
        type: null,
        name: null,
        sn: null,
        base: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {},
      tableData: [],
      headers: {
        "Access-Token": this.$store.state.token,
      },
      showHkVideo: false,
      pickerOptions: {
        disabledDate(time) {
          let now = new Date(); //获取此时的时间
          let nowData = new Date( //获取此时年月日的后一天
            now.getFullYear(),
            now.getMonth(),
            now.getDate() + 1 //获取明天
          );
          return (
            time.getTime() > nowData.getTime() - 1000 //可以选择到今天的xxx:xxx:xxx:23:59:59，只有的全部disabled
            // || time.getTime() < oneMonthAgo.getTime() //小于一个月的全部disabled掉
          );
        },
      },
      realtimeDataOptions: [],
      snInfo: null,
      yzdList: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询淤地坝设备信息列表 */
    getList() {
      this.loading = true;
      Axios.get("/hzyApi/hwDocking/getYdbSensorData", {
        params: this.queryParams,
        headers: this.headers,
      }).then((res) => {
        // console.log("res-------", res)
        if (res.data.code == 200) {
          this.ydbSensoerInfoOldList = res.data.rows;
          this.total = res.data.total;
        }
        this.loading = false;
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 通过时间获取历史数据 */
    handleQueryByTime() {
      if (!this.form.checkTime) {
        this.$modal.alertWarning("请先填写时间");
        return;
      }
      if (this.chart) {
        this.chart.dispose();
      }
      this.$modal.loading("加载中，请稍候...");
      Axios.get("/hzyApi/hwDocking/getSensorDataByTimes", {
        params: {
          sn: this.form.sn,
          sTime: this.$moment(this.form.checkTime[0]).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          eTime: this.$moment(this.form.checkTime[1]).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
        },
        headers: this.headers,
      }).then((res) => {
        // console.log("res---getSensorDataByTimes-", res);
        if (res.data.code == 200) {
          switch (this.snInfo.type) {
            // 水位
            case "1":
            case "2":
              this.$nextTick(() =>
                this.renderSWData(this.sortMapForDate(res.data.data))
              );
              break;
            // 雨量
            case "3":
              this.$nextTick(() =>
                this.renderRainData(this.sortMapForDate(res.data.data))
              );
              break;
            // 渗流
            case "4":
              break;
            // 位移
            case "5":
              this.$nextTick(() => this.renderWYData(res.data.data));
              break;
            // 渗压
            case "6":
              break;
          }
        } else {
          this.$modal.msgWarning(res.data.msg);
          if (this.chart) {
            this.chart.dispose();
          }
          document.getElementById("chart-box").innerText = "暂无数据";
        }
        this.$modal.closeLoading();
      });
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    /** 通过ydbdm获取视频流地址 */
    onClickSP(row) {
      this.$modal.loading("加载中，请稍候...");
      Axios.get("/hzyApi/hwDocking/getHkPresetsByYdbBulidId",{
        params: { 
          id: row.id,
          type: "1"
         },
        headers: {
          "Access-Token": this.$store.state.token,
        },
      }).then(res => { 
        if (res.data.code == 0) {
          this.yzdList = res.data.data.list;
        }
      })
      Axios.get("/hzyApi/hwDocking/getHkByYdbdm", {
        params: { ydbdm: row.ydbdm },
        headers: {
          "Access-Token": this.$store.state.token,
        },
      }).then((res) => {
        if (res.data.code == 0) {
          this.showHkVideo = true;
          this.videoInfo = {
            ...row,
            url: res.data.data.url,
          }
        } else {
          this.$modal.msgError(res.data.msg);
        }
        this.$modal.closeLoading();
      });
    },
    /**
     * 通过ydbdm获取当前传感器的实时数据
     * @param {*} row 从表格中获取ydbdm
     * @param {*} type 当前传感器类型
     */
    getSnListByType(row, type) {
      this.realtimeDataOptions = [];
      this.snInfo = null;
      if (this.chart) {
        this.chart.dispose();
        document.getElementById("chart-box").innerText = "暂无数据";
      }
      this.$modal.loading("加载中，请稍候...");
      // console.log("row=====", row);
      Axios.get("/hzyApi/hwDocking/getSensorInfoByYdbIdAndType", {
        params: {
          ydbId: row.id,
          type: type,
        },
        headers: this.headers,
      }).then((res) => {
        // console.log("res==传感器列表=====", res)
        if (res.data.code == 200) {
          this.realtimeDataOptions = res.data.data ?? [];
          if (this.realtimeDataOptions && this.realtimeDataOptions.length > 0) {
            this.snInfo = this.realtimeDataOptions[0];
            this.snInfo.ydbmc = row.ydbmc;
            this.getSensorRealtimeData();
          } else {
            this.snInfo = null;
            this.$modal.closeLoading();
            this.$modal.msgWarning("未配置对应的传感器列表。");
          }
        } else {
          this.snInfo = null;
        }
      });
    },
    /** 获取选中的传感器实时数据 */
    getSensorRealtimeData() {
      Axios.get("/hzyApi/hwDocking/getSensorDataBySn", {
        params: {
          ydbId: this.snInfo.ydbId,
          sn: this.snInfo.sn,
        },
        headers: this.headers,
      }).then((res) => {
        // console.log("getSensorRealtimeData-----", res);
        if (res.data.code == 200) {
          const nowMilli = new Date().getTime();
          this.title = this.snInfo.ydbmc + "-" + this.snInfo.name;
          this.form = {
            ...this.snInfo,
            ...res.data.data,
            checkTime: [nowMilli - 24 * 60 * 60 * 1000, nowMilli],
          };
          this.open = true;
          if (!this.form.history || this.form.history.length == 0) {
            this.$modal.closeLoading();
            this.$modal.msgError("获取数据列表为空！");
            return;
          }
          switch (this.snInfo.type) {
            // 水位
            case "1":
            case "2":
              this.$nextTick(() =>
                this.renderSWData(this.sortMapForDate(this.form.history))
              );
              break;
            // 雨量
            case "3":
              this.$nextTick(() =>
                this.renderRainData(this.sortMapForDate(this.form.history))
              );
              break;
            // 渗流
            case "4":
              break;
            // 位移
            case "5":
              this.$nextTick(() => this.renderWYData(this.form.history));
              break;
            // 渗压
            case "6":
              break;
          }
          this.$modal.closeLoading();
        } else {
          this.$modal.closeLoading();
          this.$modal.msgError("数据获取异常…");
        }
      });
    },
    /**  通过map的key转换为时间戳排序*/
    sortMapForDate(historyMap) {
      let entries = Object.entries(historyMap);
      entries.sort((a, b) => {
        const aMilli = this.$moment(a[0]);
        const bMilli = this.$moment(b[0]);
        return aMilli.valueOf() - bMilli.valueOf();
      });

      const obj = {};
      entries.forEach((ele) => {
        obj[ele[0]] = ele[1];
      });

      return obj;
    },
    /** 渲染雨量数据-柱状图 */
    renderRainData(historyMap) {
      if (!historyMap) {
        return;
      }
      if (this.chart) {
        this.chart.dispose();
      }
      let xAxis = [];
      let yAxis = [];

      Object.keys(historyMap).forEach((key) => {
        xAxis.push(key);
        yAxis.push(historyMap[key]);
      });

      this.chart = echarts.init(document.getElementById("chart-box"));
      const option = {
        tooltip: {
          trigger: "axis",
        },
        dataZoom: [
          {
            show: true,
          },
        ],
        grid: {
          left: "1%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: xAxis,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value} mm",
          },
        },
        series: [
          {
            data: yAxis,
            type: "bar",
            itemStyle: {
              color: "rgba(12, 209, 248, 1)",
            },
          },
        ],
      };

      option && this.chart.setOption(option);
    },
    /** 渲染水位数据-折线图 */
    renderSWData(historyMap) {
      if (!historyMap) {
        return;
      }

      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }

      let xAxis = [];
      let yAxis = [];

      Object.keys(historyMap).forEach((key) => {
        xAxis.push(key);
        yAxis.push(historyMap[key]);
      });
      this.chart = echarts.init(document.getElementById("chart-box"));
      const option = {
        tooltip: {
          trigger: "axis",
        },
        dataZoom: [
          {
            show: true,
          },
        ],
        grid: {
          top: "5%",
          left: "1%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: xAxis,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value} m",
          },
        },
        series: [
          {
            data: yAxis,
            type: "line",
            itemStyle: {
              color: "rgba(12, 209, 248, 1)",
            },
          },
        ],
      };

      option && this.chart.setOption(option);
    },
    /** 渲染位移数据-折线图XYZ */
    renderWYData(historyMap) {
      if (!historyMap) {
        return;
      }
      if (this.chart) {
        this.chart.dispose();
      }
      let xAxis = [];
      let xLine = [];
      let yLine = [];
      let zLine = [];

      for (let i = 0; i < historyMap.length; i++) {
        const ele = historyMap[i];
        xAxis.push(ele.time);
        xLine.push(ele.totalDX);
        yLine.push(ele.totalDY);
        zLine.push(ele.totalDZ);
      }

      this.chart = echarts.init(document.getElementById("chart-box"));
      const option = {
        tooltip: {
          trigger: "axis",
        },
        dataZoom: [
          {
            show: true,
          },
        ],
        grid: {
          top: "5%",
          left: "1%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xAxis,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value} mm",
          },
        },
        series: [
          {
            name: "X",
            type: "line",
            data: xLine,
          },
          {
            name: "Y",
            type: "line",
            data: yLine,
          },
          {
            name: "Z",
            type: "line",
            data: zLine,
          },
        ],
      };

      option && this.chart.setOption(option);
    },
  },
};
</script>

<style scoped>
.table-box {
  height: 90vh;
  overflow: hidden;
}
.current-info {
  width: 100%;
  display: flex;
  align-items: center;
  margin: 2vh 0;
}
.c-item {
  margin-right: 4vh;
}
#chart-box,
.empty {
  width: 100%;
  height: 50vh;
  line-height: 50vh;
  text-align: center;
}
:deep(.sy-btn) {
  background: rgb(201, 74, 252);
  border-color: rgb(201, 74, 252);
  color: #fff;
}
:deep(.sw-btn) {
  background: palevioletred;
  border-color: palevioletred;
  color: #fff;
}
</style>
